<template>
  <div class="m-5">
    <h2>My visionboards</h2>
    <hr />

    <p style="font-size: 14pt; color: gray;" class="mt-4 mb-6"> Currently only one Visionboard is allowed. </p>

    <div class="clearfix" v-if="ready_visionboards">
      <InlineVisionboardCard
        v-for="visionboard in my_visionboard_settings"
        :key="visionboard.$key"
        :visionboard="visionboard"
        />

      <el-card class="inline-goal-card inline-goal-card--dashed" @click.native="onAddVisionboard(false)" >
        <div class="text-center pt-6">
          <div><font-awesome-icon size="3x" :icon="['fas', 'plus-circle']"/></div>
          <div>New Visionboard</div>
        </div>
      </el-card>

      <!-- TODO: Ivvitation component -->
      <el-card
        v-for="(invitation, invitation_idx) in visionboards_invite_list"
        :key="'invitation'+invitation_idx"
        class="inline-goal-card">
        <div>
          <header> {{invitation.cachedVisionboardName}} </header>
          <p>
            You got an invitation to <strong>{{invitation.cachedVisionboardName}}</strong>
            from <strong>{{invitation.cachedSenderName}}.</strong><br /><br />
            <span>{{invitation.invitedAt|calendarDateFromFirebase}}</span>
          </p>
          <footer>
            <el-button @click="onAcceptOrDeclineInvitation(invitation.id, invitation.cachedVisionboardName, true)">Accept</el-button>
            <el-button @click="onAcceptOrDeclineInvitation(invitation.id, invitation.cachedVisionboardName, false)" type="danger">Decline</el-button>
          </footer>
        </div>
      </el-card>
    </div>

    <h2 class="mt-8">Archived visionboards</h2>
    <hr />

    <el-button type="text" @click="show_archived_visionboards = !show_archived_visionboards">
      {{ show_archived_visionboards ? 'Hide achieved visionboards' : 'Show achieved visionboards' }}
    </el-button>
    <div class="clearfix" v-if="show_archived_visionboards">
      <InlineVisionboardCard
        v-for="visionboards in archived_visionboards_settings"
        :key="visionboards.$key"
        :visionboards="visionboards"
        />
      <!-- TODO: Show restore archived visionboards option -->
      <div v-if="archived_visionboards_settings.length === 0">
        No achieved visionboards.
      </div>
    </div>
  </div>
</template>

<script>
import InlineVisionboardCard from "@/components/VisionboardPage/Components/InlineVisionboardCard"

export default {
  name: "VisionboardOverviewPage",
  data: () => ({
    ready_visionboards: true,
    show_archived_visionboards: false,
  }),
  computed: {
    // ...mapReady('visionboards'),

    user_visionboard_settings() {
      return this.$models.userVisionboardSettings.subscribeList();
    },

    visionboard_meta_map() {
      return {}
      /*
      let visionboard_meta_map = {}
      for ( var visionboardSettingsId in this.user_visionboard_settings.items ) {
        if ( !visionboardSettingsId ) {
          continue
        }
        let visionboardMeta = this.$models.visionboardMeta.getNode( visionboardSettingsId );
        visionboard_meta_map[ visionboardSettingsId ] = {
          deleted: visionboardMeta.deleted || false
        }
      }
      return visionboard_meta_map
      */
    },

    my_visionboard_settings() {
      return [
        { $key: 1, $id: 1 }
      ]
      /*
      const map = this.visionboard_meta_map
      return this.user_visionboard_settings
        .itemsAsArray()
        .filter( item => !map[ item.$id ].deleted && !map[ item.$id ].team )
      */
    },

    visionboards_invite_list() {
      return []
      /*
      let user = this.userData;
      if (user && 'visionboardInviteList' in user) {
        return Object.keys(user.visionboardInviteList).map(key => {
          return { ...user.visionboardInviteList[key], id: key };
        });
      } else {
        return [];
      }
      */
    },

    archived_visionboards_settings() {
      return []
      /*
      return this.user_visionboard_settings
        .itemsAsArray()
        .filter( item => this.visionboard_meta_map[ item.$id ].deleted )
      */
    },
  },
  methods: {
    onAddVisionboard() {
      this.$root.showNewModal('visionboard', {});
    },
    onAcceptOrDeclineInvitation(invitation_id, invitation_name, accept) {
      this.$api.visionboard_accept_or_decline_invitation({
        visionboard_id:   invitation_id,
        visionboard_name: invitation_name,
        accept:           accept
      })
    },
  },
  components: {
    InlineVisionboardCard
  }
};
</script>
